export class MatomoMockTracking {
    setUserID(userId: number | string): void {
        //
    }
}
